import { render, staticRenderFns } from "./Planet.vue?vue&type=template&id=08047bb4&scoped=true"
import script from "./Planet.vue?vue&type=script&lang=js"
export * from "./Planet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08047bb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08047bb4')) {
      api.createRecord('08047bb4', component.options)
    } else {
      api.reload('08047bb4', component.options)
    }
    module.hot.accept("./Planet.vue?vue&type=template&id=08047bb4&scoped=true", function () {
      api.rerender('08047bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/components/Planet.vue"
export default component.exports